import jwtDecode from 'jwt-decode';
import { Cookies } from "react-cookie";
import {
    firebaseFire as Libfirebase,
} from '../helpers/firebase-config';

/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
    const user = getLoggedInUser();
    // console.log("user ----", user)
    if (!user) {
        return false;
    }

    return true;
    const decoded = jwtDecode(user.token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
        console.warn('access token expired');
        return false;
    }
    else {
        return true;
    }
}

const isUserLoggedFlag = async (ref) => {
    // PRECISO VERIFICAR NA BASE DE DADOS SE A FLAG LOGADO
    const userDb = await Libfirebase.doc(ref).get()
    return userDb.data().logged
}

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {
    const cookies = new Cookies();
    const user = cookies.get("user");
    return user ? (typeof (user) === 'object' ? user : JSON.parse(user)) : null;
}

const hasPermission = (permissions) => {
    const user = getLoggedInUser()
    // if(permissions.includes('*')){
    //     return true
    // }
    // console.log(user.permissao instanceof Array)
    if (user) {
        const permissoes = user.permissao.split(",")
        if (permissoes.length === 0) {
            return false;
        }

        if (permissoes.length > 1) {
            for (let index = 0; index < permissions.length; index++) {
                const permission = permissions[index];
                if (permissoes.includes(permission) === true) {
                    return true
                }
            }
            return false
        } else {
            return permissions.includes(permissoes[0].toString())
        }
    }

}

export { isUserAuthenticated, getLoggedInUser, hasPermission };